<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-modal-print
                                ref="print"
                                @close-method="(file_name = null), $refs.print.close()"
                                :file-name="file_name"
                                :no-button="true"
                            ></bc-modal-print>
                            <v-menu left content-class="no-stripe">
                                <template slot="activator">
                                    <v-btn icon>
                                        <v-icon>more_vert</v-icon>
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-tile @click="dev_mode ? showPrinter() : printLabel()">
                                        <v-list-tile-title> Print </v-list-tile-title>
                                    </v-list-tile>
                                    <v-list-tile @click="$router.push({ name: 'packing_list_profile', params: { id: currObjField('packing_list_id') } })">
                                        <v-list-tile-title>
                                            {{ "View Packing List" }}
                                        </v-list-tile-title>
                                    </v-list-tile>
                                    <v-list-tile
                                        v-if="currObjField('has_invoice') == '1'"
                                        @click="$router.push({ name: 'invoice', params: { id: currObjField('invoice_id') } })"
                                    >
                                        <v-list-tile-title>
                                            {{ "View Invoice" }}
                                        </v-list-tile-title>
                                    </v-list-tile>
                                </v-list>
                            </v-menu>
                            <!-- <bc-btn-refresh
                                permanent
                                @invoke-method="dbGetBillOfLading()"
                            ></bc-btn-refresh> -->
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text>
                    <v-card elevation="10">
                        <app-section-loader :status="section_loader"></app-section-loader>
                        <v-card-text>
                            <div
                                v-if="currObjField('status')"
                                class="ribbon ribbon-top-right"
                                :class="
                                    currObjField('status') == 'sent' && new Date(currObjField('date_due')).getTime() < new Date(current_day).getTime()
                                        ? 'ribbon-red'
                                        : `ribbon-${currObjField('status_class')}`
                                "
                            >
                                <span class="ribbon-span">{{ currObjField("status") }}</span>
                            </div>
                            <v-layout row wrap class="px-3 pt-3 pb-1 rounded">
                                <v-flex xs12 sm4 pb-3 align-self-start>
                                    <span class="fs-14">{{ $t("lang.company") }}</span>
                                    <h3>{{ currObjField("company") ? currObjField("company") : "---" }}</h3>
                                </v-flex>
                                <v-flex xs12 sm4 pb-3 align-self-start>
                                    <span class="fs-14">Sold To</span>
                                    <h3 style="white-space: pre">{{ currObjField("sold_to_address_label") || "---" }}</h3>
                                    <h3 style="white-space: pre">{{ currObjField("sold_to_address") || "---" }}</h3>
                                </v-flex>
                                <v-flex xs12 sm4 pb-3 align-self-start>
                                    <span class="fs-14">Ship To</span>
                                    <h3 style="white-space: pre">{{ currObjField("ship_to_address_label") || "---" }}</h3>
                                    <h3 style="white-space: pre">{{ currObjField("ship_to_address") || "---" }}</h3>
                                </v-flex>
                                <v-flex xs12 sm4 pb-3 align-self-start>
                                    <span class="fs-14">{{ $t("lang.carrier_id") }}</span>
                                    <h3>{{ currObjField("shipping_provider") ? currObjField("shipping_provider") : "---" }}</h3>
                                </v-flex>
                                <v-flex xs12 sm4 pb-3 align-self-start>
                                    <span class="fs-14">{{ $t("lang.salesman_id") }}</span>
                                    <h3>{{ currObjField("created_by") ? currObjField("created_by") : "---" }}</h3>
                                </v-flex>
                                <v-flex xs12 sm4 pb-3 align-self-start>
                                    <span class="fs-14">{{ $t("lang.payment_term") }}</span>
                                    <h3>{{ currObjField("payment_term_description") ? currObjField("payment_term_description") : "---" }}</h3>
                                </v-flex>
                                <v-flex xs12 sm4 pb-3 align-self-start>
                                    <span class="fs-14">{{ $t("lang.date_shipped") }}</span>
                                    <h3>{{ currObjField("date_shipped") ? currObjField("date_shipped") : "---" }}</h3>
                                </v-flex>
                                <v-flex xs12 sm4 pb-3 align-self-start>
                                    <span class="fs-14">{{ $t("lang.shipper_number") }}</span>
                                    <h3>{{ currObjField("packing_list_id") }}</h3>
                                </v-flex>
                            </v-layout>
                            <v-form ref="bill_of_lading">
                                <v-layout row wrap :key="update_bol">
                                    <v-flex xs12 pt-3>
                                        <v-data-table
                                            v-if="currObjField('invoice_details') != null && bill_of_lading.repack"
                                            :headers="detail_headers"
                                            :items="currObjField('repack') || []"
                                            hide-actions
                                            class="border"
                                        >
                                            <template slot="items" slot-scope="props">
                                                <tr>
                                                    <td>
                                                        {{ props.item.shipping_unit }}
                                                    </td>
                                                    <td>
                                                        <v-icon v-if="props.item.hazardous_material == '1'">disabled_by_default</v-icon>
                                                    </td>
                                                    <td>{{ props.item.name }}</td>
                                                    <td>
                                                        <v-text-field
                                                            v-model="bill_of_lading.repack[props.index].shipping_weight"
                                                            single-line
                                                            hide-details
                                                            @input="calcTotalShippingWeight()"
                                                            :rules="ifValid('bill_of_lading.shipping_weight')"
                                                            type="number"
                                                        ></v-text-field>
                                                    </td>
                                                </tr>
                                                <tr v-if="props.index == currObjField('repack').length - 1">
                                                    <td></td>
                                                    <td></td>
                                                    <td class="text-right fw-bold">Total Shipping Weight</td>
                                                    <td class="fw-bold">{{ total_shipping_weight }}</td>
                                                </tr>
                                            </template>
                                        </v-data-table>
                                    </v-flex>
                                    <v-flex xs12 style="font-size: 10px">
                                        &nbsp;&nbsp;When transporting hazardous materials include the technical or chemical name for the n.o.s (not otherwise
                                        specified in) or generic description of material with appropriate UN or NA number as identified in the US. Emergency
                                        Communication Standard (HM-126C). Provide emergency response phone number in case of incident or accident in box.
                                    </v-flex>
                                    <v-flex xs6 border border-left-0>
                                        <v-text-field
                                            v-model="bill_of_lading.cod_address"
                                            :label="$t('lang.cod_address')"
                                            full-width
                                            hide-details
                                            :counter="showCounter(bill_of_lading.cod_address, 'bill_of_lading.cod_address')"
                                            :rules="ifValid('bill_of_lading.cod_address')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs3 border>
                                        <v-text-field
                                            v-model="bill_of_lading.cod_amount"
                                            :label="$t('lang.cod_amount')"
                                            full-width
                                            prefix="$"
                                            hide-details
                                            :counter="showCounter(bill_of_lading.cod_amount, 'bill_of_lading.cod_amount')"
                                            :rules="ifValid('bill_of_lading.cod_amount')"
                                            type="number"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs3 border border-right-0>
                                        <v-layout row wrap>
                                            <v-flex xs12 sm5 pl-1 my-auto> {{ $t("lang.cod_fee") }}: </v-flex>
                                            <v-flex xs12 sm7>
                                                <v-text-field
                                                    v-model="bill_of_lading.cod_fee"
                                                    full-width
                                                    hide-details
                                                    prefix="$"
                                                    single-line
                                                    :counter="showCounter(bill_of_lading.cod_fee, 'bill_of_lading.cod_fee')"
                                                    :rules="ifValid('bill_of_lading.cod_fee')"
                                                    type="number"
                                                ></v-text-field>
                                            </v-flex>
                                        </v-layout>
                                        <v-radio-group
                                            v-model="bill_of_lading.cod_fee_collect"
                                            row
                                            class="mt-0 ml-1"
                                            :rules="ifValid('bill_of_lading.cod_fee_collect')"
                                            hide-details
                                        >
                                            <v-layout align-start :class="$bp.smAndDown ? 'column' : 'row'">
                                                <v-radio label="Prepaid" value="0"></v-radio>
                                                <v-radio label="Collect" value="1"></v-radio>
                                            </v-layout>
                                        </v-radio-group>
                                    </v-flex>
                                    <v-flex xs3 border border-left-0>
                                        <span style="font-size: 10px" class="px-1 pt-1">
                                            &nbsp;&nbsp;NOTE - Where the rate is dependent on value, shippers are required to state specifically in writing the
                                            agreed or declared value of the property.<br />
                                            &nbsp;&nbsp;The Agreed or declared value of the property is hereby specifically stated by the shipper to be not
                                            exceeding
                                        </span>
                                        <v-layout row>
                                            <v-flex xs6>
                                                <v-text-field
                                                    v-model="bill_of_lading.declared_value"
                                                    single-line
                                                    hide-details
                                                    prefix="$"
                                                    class="mr-1"
                                                    :counter="showCounter(bill_of_lading.declared_value, 'bill_of_lading.declared_value')"
                                                    :rules="ifValid('bill_of_lading.declared_value')"
                                                    type="number"
                                                ></v-text-field>
                                            </v-flex>
                                            <span class="my-auto">Per</span>
                                            <v-flex xs6>
                                                <v-text-field single-line hide-details class="ml-1" type="number"></v-text-field>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                    <v-flex xs3 border column>
                                        <span style="font-size: 10px" class="px-1"
                                            >This is to certify that the above named materials are properly classified, described, packaged, marked, and labeled
                                            and are in proper condition for transportation according to the applicable regulations of the Department of
                                            Transportation.</span
                                        >
                                        <v-text-field :label="$t('lang.signature')" hide-details class="px-2 align-center pb-2"></v-text-field>
                                    </v-flex>
                                    <v-flex xs3 border column>
                                        <span style="font-size: 10px" class="px-1 pt-1">
                                            &nbsp;&nbsp;Subject to Section 7 of conditions, if this shipment is to be delivered to the consignee without
                                            recourse on the consignor, the consignor shall sign the following statement:<br />
                                            &nbsp;&nbsp;The carrier shall not make delivery of this shipment without payment of freight and all other lawful
                                            charges.
                                        </span>
                                        <v-text-field :label="$t('lang.signature_of_cosignor')" hide-details class="px-2"></v-text-field>
                                    </v-flex>
                                    <v-flex xs3 border column border-right-0>
                                        <v-text-field
                                            v-model="bill_of_lading.total_charges"
                                            :label="$t('lang.total_charges')"
                                            full-width
                                            hide-details
                                            prefix="$"
                                            :counter="showCounter(bill_of_lading.total_charges, 'bill_of_lading.total_charges')"
                                            :rules="ifValid('bill_of_lading.total_charges')"
                                            type="number"
                                        ></v-text-field>
                                        <v-divider class="my-0" style="border-top-width: 2px"></v-divider>
                                        <v-layout row wrap>
                                            <v-flex xs12 sm5 pl-1 my-auto> {{ $t("lang.freight_charges") }}: </v-flex>
                                            <v-flex xs12 sm7>
                                                <v-text-field
                                                    v-model="bill_of_lading.freight_charges"
                                                    full-width
                                                    hide-details
                                                    prefix="$"
                                                    single-line
                                                    :counter="showCounter(bill_of_lading.freight_charges, 'bill_of_lading.freight_charges')"
                                                    :rules="ifValid('bill_of_lading.freight_charges')"
                                                    type="number"
                                                ></v-text-field>
                                            </v-flex>
                                        </v-layout>
                                        <v-radio-group
                                            v-model="bill_of_lading.freight_collect"
                                            row
                                            class="mt-0 ml-1"
                                            :rules="ifValid('bill_of_lading.freight_collect')"
                                            hide-details
                                        >
                                            <v-layout align-start :class="$bp.smAndDown ? 'column' : 'row'">
                                                <v-radio label="Prepaid" value="0"></v-radio>
                                                <v-radio label="Collect" value="1"></v-radio>
                                            </v-layout>
                                        </v-radio-group>
                                    </v-flex>
                                    <v-flex xs12 style="font-size: 9px" py-1 border border-right-0 border-left-0>
                                        &nbsp;&nbsp;RECEIVED, subject to the classifications and lawfully filed tariffs in effect on the date of this Bill of
                                        Lading, the property described above in apparent good order, except as noted (contents and conditions of packages
                                        unknown), marked, consigned, and destined as indicated above which said carrier (the word carrier being understood
                                        throughout the contract as meaning any person or corporation in possession of property under the contract) agrees to
                                        carry to its usual place of delivery at said destination if on its route, otherwise to deliver to another carrier on the
                                        route to said destination. It is mutually agreed, as to each carrier of all or any said property, over all or any
                                        portion of said route to destination and as to each party at any time interested in all or any said property, that every
                                        service to be performed hereunder shall be subject to all Bill of Lading terms and conditions in the governing
                                        classification on the date of shipment. Shipper hereby certifies that he is familiar with all the Bill of Lading terms
                                        and conditions in the governing classification and the said terms and conditions are hereby agreed to the shipper and
                                        accepted for himself and his assigns.<br />
                                        &nbsp;&nbsp;NOTICE: Freight moving under this Bill of Lading is subject to the classifications and lawfully filed
                                        tariffs in effect on the date of this Bill of Lading. This notice supersedes and negates any claimed, alleged or
                                        asserted oral or written contract, promise, representation or understanding between the parties with respect to this
                                        freight, except to the extent of any written contract which establishes lawful contract carriage and is signed by
                                        authorized representatives of both parties to the contract.
                                    </v-flex>
                                    <v-flex xs6 border border-left-0>
                                        <v-text-field
                                            v-model="bill_of_lading.shipper"
                                            :label="$t('lang.shipper')"
                                            full-width
                                            hide-details
                                            :counter="showCounter(bill_of_lading.shipper, 'bill_of_lading.shipper')"
                                            :rules="ifValid('bill_of_lading.shipper')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs6 border border-right-0>
                                        <v-layout row wrap>
                                            <v-flex xs6>
                                                <v-text-field
                                                    :value="currObjField('carrier')"
                                                    :label="$t('lang.carrier_id')"
                                                    full-width
                                                    hide-details
                                                    readonly
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs6>
                                                <v-text-field
                                                    :value="currObjField('date_shipped')"
                                                    :label="$t('lang.date')"
                                                    readonly
                                                    hide-details
                                                    full-width
                                                    append-icon="event"
                                                ></v-text-field>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                    <v-flex xs6 border border-left-0>
                                        <v-text-field label="Per" full-width hide-details></v-text-field>
                                    </v-flex>
                                    <v-flex xs6 border border-right-0>
                                        <v-text-field label="Per" full-width hide-details></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 border-top style="font-size: 10px" mb-2>
                                        * HAZARDOUS MATERIALS MARK WITH "X" TO DESIGNATE HAZARDOUS MATERIAL AS REFERNCED IN 49CFR § 172.202.
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-btn color="error" @mouseup.left="$refs.delete_bol.openDialog()" class="mr-auto">{{ $t("lang.delete") }}</v-btn>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-btn color="success" @mouseup.left="modifyBillOfLading('patch')" class="ml-auto">{{ $t("lang.save") }}</v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-form>
                        </v-card-text>
                    </v-card>
                </v-card-text>
            </v-card>
            <delete-confirmation-dialog
                ref="delete_bol"
                :heading="$t('lang.delete_bill_of_lading')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="modifyBillOfLading('delete')"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { store } from "Store/store";
import _ from "lodash";

export default {
    data() {
        return {
            update_bol: 0,
            total_shipping_weight: 0,
            section_loader: false,
            detail_headers: [
                { text: this.$t("lang.unit"), sortable: false },
                { text: "HM*", sortable: false },
                { text: this.$t("lang.part_name"), sortable: false },
                { text: this.$t("lang.weight"), sortable: false },
            ],
            printOptions: [
                { title: "print_invoice", type: "invoice" },
                { title: "print_all", type: "all" },
            ],
            bill_of_lading: {
                packing_list_id: "",
                vehicle_number: "",
                total_ship_weight: "",
                cod_address: "",
                cod_amount: "",
                cod_fee: "",
                cod_fee_collect: "",
                declared_value: "",
                total_charges: "",
                freight_charges: "",
                freight_collect: "",
                // date_shipped: "",
                shipper: "DOWA THT AMERICA, INC.",
                // carrier_id: "",
            },
            repack_dialog: false,
            customers: null,
            selected_invoices: [],
            selected_repacks: [],
            current_obj: null,
            file_name: null,
            filter: {
                search: "",
                company_id: "",
                page_size: 0,
                page_num: 0,
            },
            invoice_dialog: false,
            dbGetBillOfLading: _.debounce(this.getBillOfLading, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        store.dispatch("fetchShippingCarriers", {
            url: "shipping_carriers",
            method: "get",
            stateProperty: "shipping_carriers",
            commit: true,
        });
        store.dispatch("fetchSetting", {
            url: "shipping_unit_options",
            method: "get",
            stateProperty: "shipping_unit_options",
            commit: true,
        });

        const bill_of_lading = new Promise((resolve, reject) => {
            store
                .dispatch("fetchBillOfLading", {
                    url: "bill_of_ladings/" + to.params.id,
                    method: "get",
                    stateProperty: "bill_of_lading",
                    commit: true,
                })
                .then((data) => {
                    typeof data !== "undefined" && data.bill_of_lading ? resolve(data.bill_of_lading) : reject(new Error("reject"));
                });
        });
        Promise.all([bill_of_lading])
            .then(([bill_of_lading]) => {
                next((vm) => {
                    vm.assignObj(vm.bill_of_lading, bill_of_lading);
                    vm.bill_of_lading.repack = vm.currObjField("repack").map(({ repack_id, shipping_weight, hazardous_material, shipping_unit_id }) => ({
                        repack_id,
                        shipping_weight,
                        hazardous_material,
                        shipping_unit_id,
                    }));
                    vm.calcTotalShippingWeight();
                    vm.$store.commit("toggleModalLoader", false);
                    vm.finishLoader();
                });
            })
            .catch((error) => {
                next({ name: "packing_lists", replace: true }); //if any of them error, don't go to route, else set variables and proceed to route
            });
    },
    beforeRouteUpdate(to, from, next) {
        this.$store.dispatch("fetchShippingCarriers", {
            url: "shipping_carriers",
            method: "get",
            stateProperty: "shipping_carriers",
            commit: true,
            body: { options: 1, department_id: "2" },
        });
        this.$store.dispatch("fetchSetting", {
            url: "shipping_unit_options",
            method: "get",
            stateProperty: "shipping_unit_options",
            commit: true,
        });
        const bill_of_lading = new Promise((resolve, reject) => {
            this.$store
                .dispatch("fetchBillOfLading", {
                    url: "bill_of_ladings/" + to.params.id,
                    method: "get",
                    stateProperty: "bill_of_lading",
                    commit: true,
                })
                .then((data) => {
                    typeof data !== "undefined" && data.bill_of_lading ? resolve(data.bill_of_lading) : reject(new Error("reject"));
                });
        });

        Promise.all([bill_of_lading])
            .then(([bill_of_lading]) => {
                this.assignObj(this.bill_of_lading, bill_of_lading);
                this.bill_of_lading.repack = this.currObjField("repack").map(({ repack_id, shipping_weight, hazardous_material, shipping_unit_id }) => ({
                    repack_id,
                    shipping_weight,
                    hazardous_material,
                    shipping_unit_id,
                }));
                this.calcTotalShippingWeight();
                this.$store.commit("toggleModalLoader", false);
                this.finishLoader();
                next();
            })
            .catch((error) => {
                next({ name: "packing_lists", replace: true }); //if any of them error, path to packing_list
            });
    },
    computed: {
        ...mapState({
            rules_bill_of_lading: (state) => state.validation.rules_bill_of_lading,
            profile: (state) => state.bill_of_ladings.bill_of_lading,
            shipping_carriers: (state) => state.shipping_carriers.shipping_carriers,
            shipping_unit_options: (state) => state.settings.shipping_unit_options,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
        currObjField() {
            return (field) => {
                return this.profile && field && this.profile[field] ? this.profile[field] : "";
            };
        },
    },
    methods: {
        calcTotalShippingWeight() {
            this.total_shipping_weight = this.bill_of_lading.repack ? _.sum(this.bill_of_lading.repack.map((r) => +r.shipping_weight || 0)) : 0;
        },
        getBillOfLading() {
            this.startLoader();
            this.$store
                .dispatch("fetchBillOfLading", {
                    url: `bill_of_ladings/${this.$route.params.id}`,
                    method: "get",
                    stateProperty: "bill_of_lading",
                    commit: true,
                })
                .then((data) => {
                    if (typeof data === "undefined") {
                        this.$router.push({ name: "packing_lists" });
                    } else {
                        this.bill_of_lading.repack = this.currObjField("repack").map(
                            ({ repack_id, shipping_weight, hazardous_material, shipping_unit_id }) => ({
                                repack_id,
                                shipping_weight,
                                hazardous_material,
                                shipping_unit_id,
                            })
                        );
                    }
                })
                .finally(() => {
                    this.finishLoader(true);
                });
        },
        modifyBillOfLading(method = null) {
            if (method) {
                this.$store.commit("validationOn");
                this.$nextTick(() => {
                    if (this.validateForm("bill_of_lading")) {
                        this.section_loader = true;
                        let current_packing_list = { ...this.profile };
                        this.$store
                            .dispatch("fetchBillOfLading", {
                                pk: "bol_id",
                                id: this.$route.params.id,
                                url: `bill_of_ladings/${this.$route.params.id}`,
                                method: method,
                                stateProperty: "bill_of_lading",
                                commit: true,
                                body: this.bill_of_lading,
                            })
                            .then((data) => {
                                if (data && data.code == "200") {
                                    this.$store.commit("validationOff");
                                    if (method == "delete") {
                                        this.$router.push({ name: "packing_list_profile", params: { id: current_packing_list.packing_list_id } });
                                    } else {
                                        this.bill_of_lading.repack = this.currObjField("repack").map(
                                            ({ repack_id, shipping_weight, hazardous_material, shipping_unit_id }) => ({
                                                repack_id,
                                                shipping_weight,
                                                hazardous_material,
                                                shipping_unit_id,
                                            })
                                        );
                                        this.update_bol++;
                                    }
                                }
                                this.section_loader = false;
                            });
                    }
                });
            }
        },
        showPrinter() {
            // this.startLoader();
            this.$refs.print.openDialog();

            this.$store
                .dispatch("fetchBillOfLading", {
                    url: `bill_of_ladings/print`,
                    method: "get",
                    body: {
                        bol_id: this.$route.params.id,
                    },
                })
                .then((data) => {
                    if (typeof data != "undefined" && data.bill_of_lading) {
                        this.file_name = data.bill_of_lading.file_name;
                    } else {
                        this.file_name = "";
                        this.$refs.print.close();
                        this.createAlert();
                    }
                });
        },
        printLabel() {
            this.$store.commit("toggleGlobalSnackbar", true);
            this.$store
                .dispatch("fetchBillOfLading", {
                    url: `bill_of_ladings/print`,
                    method: "get",
                    body: {
                        bol_id: this.$route.params.id,
                    },
                })
                .then((data) => {
                    if (typeof data != "undefined" && data.bill_of_lading) {
                        this.$refs.print.printReport(data.bill_of_lading.file_name);
                    } else {
                        this.createAlert();
                    }
                    this.$store.commit("toggleGlobalSnackbar", false);
                });
        },
    },
};
</script>
